import React, { useState } from "react";
import ImageModal from "./Eventos/ImageModal";

const Tarjetas = ({ eventos, onCardClick }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImages, setModalImages] = useState([]);
  const [modalIndex, setModalIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(10); // Mostrar inicialmente 10 eventos

  const handleImageClick = (images, index, event) => {
    event.stopPropagation(); // Prevenir la apertura del modal de detalles
    setModalImages(images);
    setModalIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleLoadMore = (event) => {
    event.stopPropagation(); // Evita que el clic se propague y abra el modal de detalles
    setVisibleCount((prev) => prev + 5);
  };

  const handleShowLess = (event) => {
    event.stopPropagation(); // Evita que el clic se propague y abra el modal de detalles
    setVisibleCount(10);
  };

  const obtenerFechaValida = (fecha) => {
    try {
      const fechaISO = new Date(fecha.includes("T") ? fecha : `${fecha}T12:00:00Z`);
      return isNaN(fechaISO.getTime()) ? "Fecha inválida" : fechaISO;
    } catch (error) {
      return "Fecha inválida";
    }
  };

  return (
    <div className="flex flex-col gap-4 bg-white p-6 rounded-lg shadow-lg w-full max-w-md mx-auto">
      <h2 className="text-2xl font-bold text-gray-800 text-center flex items-center justify-center gap-2">
        <span role="img" aria-label="calendario">📅</span> Eventos Recientes
      </h2>

      <div className="max-h-[600px] overflow-y-auto scrollbar-custom w-full">
        {eventos.length === 0 ? (
          <p className="text-gray-600 text-center">No hay eventos disponibles.</p>
        ) : (
          <>
            {eventos.slice(0, visibleCount).map((evento) => (
              <div
              key={evento.id}
              className={`bg-white p-4 rounded-lg shadow-md border border-gray-200 flex flex-col mb-4 ${
                !onCardClick ? "cursor-not-allowed" : "cursor-pointer"
              }`}
              onClick={onCardClick ? () => onCardClick(evento.id) : undefined} // Verificar si existe
            >
              <h3 className="text-lg font-semibold text-center text-gray-800">
                {evento.titulo}
              </h3>
              <p className="text-sm text-main-blue font-bold mt-1">
                {obtenerFechaValida(evento.fecha).toLocaleDateString(
                  "es-ES",
                  {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  }
                )}
              </p>
              {/* Descripción truncada con 3 líneas máximo */}
              <div
                className="text-sm text-gray-600 mt-2 line-clamp-3 break-words evento-preview"
                dangerouslySetInnerHTML={{ __html: evento.descripcion }}
              />
              
              {evento.salon_nombre && (
                <p className="text-sm mt-2">
                  <strong>Salón:</strong> {evento.salon_nombre}
                </p>
              )}
              {evento.asignatura_nombre && (
                <p className="text-sm text-gray-600 mt-2">
                  <strong>Asignatura:</strong> {evento.asignatura_nombre}
                </p>
              )}
              {evento.es_evento_general === 1 && (
                <p className="text-sm text-gray-600 mt-2">
                  <strong>Todo el Colegio</strong>
                </p>
              )}
                
                {evento.fotos && evento.fotos.length > 0 && (
                  <div className="relative mt-4">
                    <div className="overflow-x-auto flex items-center scrollbar-custom space-x-2 p-1">
                      {evento.fotos.map((foto, index) => (
                        <img
                          key={foto}
                          src={foto}
                          alt={`Foto del evento ${index + 1}`}
                          className="w-16 h-16 object-cover rounded flex-shrink-0 cursor-pointer shadow-lg"
                          onClick={(event) => handleImageClick(evento.fotos, index, event)}
                        />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}

            {/* Botón "Ver más" y "Ver menos" centrado y evitando la propagación del evento */}
            {eventos.length > 15 && (
              <div className="flex justify-center mt-4">
                {visibleCount < eventos.length ? (
                  <button 
                    onClick={handleLoadMore} 
                    className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
                  >
                    Ver más
                  </button>
                ) : (
                  <button 
                    onClick={handleShowLess} 
                    className="bg-gray text-white px-4 py-2 rounded-lg hover:bg-gray-600"
                  >
                    Ver menos
                  </button>
                )}
              </div>
            )}
          </>
        )}
      </div>

      <ImageModal isOpen={isModalOpen} images={modalImages} initialIndex={modalIndex} onClose={closeModal} />
    </div>
  );
};

export default Tarjetas;
